import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { Device } from '@src/types/Device';

interface DeviceByType {
  deviceId: string;
  name: string;
  type: string;
  parentControllerId?: string;
  parentSourceDeviceId?: string;
}

export default ({
  deviceType,
  options,
  queryKeys,
}: {
  deviceType: string;
  options: { enabled: boolean };
  queryKeys: string[];
}) =>
  useApiQuery<Device[], { devices: DeviceByType[] }>({
    queryKey: [...queryKeys, QueryKeys.allDevicesByType],
    apiPath: '/devices/search',
    method: 'POST',
    body: { filter: { type: deviceType, deleted: false } },
    useV2API: true,
    enabled: options.enabled,
    select: (data) => ({
      devices: (data as Device[]).map((d) => ({
        deviceId: d.deviceId,
        name: d.name,
        type: d.type,
        parentControllerId: d.parentControllerId ?? undefined,
        parentSourceDeviceId: d.parentSourceDeviceId ?? undefined,
      })),
    }),
  });
